"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.favoriteVehicleIdsReducer = void 0;
const favoriteVehicleIds_1 = require("../actions/favoriteVehicleIds");
const REDUCER_HELPERS = require("../utils/immutable-reducers");
const initState = [];
const favoriteVehicleIdsReducer = (vehicleIdsArray = initState, action) => {
    switch (action === null || action === void 0 ? void 0 : action.type) {
        case favoriteVehicleIds_1.ADD_FAVORITE:
            return [...new Set([...vehicleIdsArray, action.payload])];
        case favoriteVehicleIds_1.SET_FAVORITES:
            return [...new Set([...action.payload])];
        case favoriteVehicleIds_1.REMOVE_FAVORITE:
            return REDUCER_HELPERS.removeItem(vehicleIdsArray, action.payload);
        case favoriteVehicleIds_1.DELETE_FAVORITES:
            return [];
        default:
            return vehicleIdsArray;
    }
};
exports.favoriteVehicleIdsReducer = favoriteVehicleIdsReducer;
//# sourceMappingURL=favoriteVehicleIds.reducer.js.map